import { z } from "zod";
import { courtLevelSchema } from "./court-level";

export const courtTypeSchema = z.object({
	id: z.string().optional(),
	name: z.string(),
	code: z.string(),
	description: z.string().optional(),
	status: z.string().optional(),
	courtLevelModel: courtLevelSchema.optional(),
	court_level: z.string(),
	created_at: z.string().optional(),
	udpated_at: z.string().optional(),
});

export type CourtType = z.infer<typeof courtTypeSchema>;
